<template>
    <div class="container mt-100 mt-60">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
                <div class="position-relative">
                    <img src="../assets/images/about/about-2.png" class="img-fluid" alt="">
                    <div class="play-icon">
                        <a @click="toggle" data-type="youtube" data-id="yba7hPeTSjk"
                            class="play-btn lightbox video-play-icon">
                            <i class="mdi mdi-play text-primary rounded-circle shadow"></i>
                        </a>
                    </div>
                </div>
            </div><!--end col-->

            <div class="col-lg-7 col-md-6 mt-4 mt-lg-0 pt- pt-lg-0">
                <div class="ms-lg-4">
                    <div class="section-title">
                        <h4 class="title mb-4">About Our Treatments</h4>
                        <p class="text-muted para-desc">Great doctor if you need your family member to get effective
                            immediate assistance, examination, emergency treatment or a simple consultation. Thank you.
                        </p>
                        <p class="text-muted para-desc mb-0">The most well-known dummy text is the 'Lorem Ipsum', which
                            is said to have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin
                            language which more or less corresponds to 'proper' Latin. It contains a series of real
                            Latin words.</p>
                    </div>

                    <div class="mt-4">
                        <router-link to="/aboutus" class="btn btn-primary">Read More <i
                                class="ri-arrow-right-line align-middle"></i></router-link>
                    </div>
                </div>
            </div><!--end col-->
        </div><!--end row-->
    </div><!--end container-->

    <div :class="isActive === false ? 'position-fixed ' : 'd-none'" class="modal-video" tabindex="-1" role="dialog" area-modal="true" aria-label="You just opened the modal video">
        <div class="modal-video-body">
            <div class="modal-video-inner" >
                <div class="modal-video-movie-wrap" style="">
                    <iframe  width="460" height="230" src="//www.youtube.com/embed/yba7hPeTSjk?mute=1&amp;autoplay=1"
                        frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen="" tabindex="-1">
                    </iframe>
                    <a @click="toggle" class="mdi mdi-close m-3 text-light h4 position-class"> </a>
                </div>
                <div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from 'vue'

const isActive = ref(true)

function toggle(){
    isActive.value = !isActive.value
}

  
</script>

<style lang="scss" scoped></style>